import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-4" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control w-25",
  placeholder: "Enter Search Key !"
}, null, -1)
const _hoisted_6 = {
  type: "button",
  class: "btn btn-primary me-1 ms-1"
}
const _hoisted_7 = {
  type: "button",
  class: "btn btn-default border"
}
const _hoisted_8 = { class: "card mb-4 d-none d-md-block" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_14 = {
  key: 0,
  class: "table card-table text-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", null, "Id", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", null, "Product Name", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", null, "Category / Generic", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", null, "Unit", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", null, "Buy Price", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", null, "Sell Price", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", null, "Warning Quantity", -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "table-border-bottom-0" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0" }, "Please Add Some Product", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "mobile-view d-block d-md-none" }
const _hoisted_32 = {
  key: 0,
  class: "card"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "spinner-border text-primary",
      role: "status"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
    ])
  ])
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "card-body" }
const _hoisted_37 = { class: "text-wrap" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "mb-0 text-wrap"
}
const _hoisted_40 = { class: "mb-0 text-wrap" }
const _hoisted_41 = { class: "mb-0 text-wrap" }
const _hoisted_42 = { class: "mb-0 text-wrap" }
const _hoisted_43 = { class: "mb-0 text-wrap" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 2 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0" }, "Please Add Some Product")
  ])
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 0,
  class: "card"
}
const _hoisted_50 = { class: "card-body d-flex justify-content-around flex-wrap" }
const _hoisted_51 = { "aria-label": "Page navigation" }
const _hoisted_52 = { class: "pagination flex-wrap" }
const _hoisted_53 = ["onClick", "innerHTML"]
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = { class: "input-group" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  class: "input-group-text",
  for: "inputGroupSelect01"
}, "Size", -1)
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<option value=\"10\">10</option><option value=\"20\">20</option><option value=\"30\">30</option><option value=\"40\">40</option><option value=\"50\">50</option><option value=\"100\">100</option>", 6)
const _hoisted_64 = [
  _hoisted_58
]
const _hoisted_65 = {
  class: "modal fade",
  id: "modalCenter",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_66 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_67 = { class: "modal-content" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title text-center",
    id: "modalCenterTitle"
  }, "Delete Confirmation !"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_69 = { class: "modal-body text-center" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-bell bx-lg text-danger mb-3 d-inline-block" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", null, "Are You Sure to Delete ?", -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Page !")
const _hoisted_73 = { class: "modal-footer text-center justify-content-center" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, " Close ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'magnifying-glass'] })
            ]),
            _createElementVNode("button", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'broom'] })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.fettchDataArray.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_15,
                        (_ctx.userData?.type ==='SUPERADMIN')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_16, "Store Type"))
                          : _createCommentVNode("", true),
                        _hoisted_17,
                        _hoisted_18,
                        _hoisted_19,
                        _hoisted_20,
                        _hoisted_21,
                        _hoisted_22,
                        (_ctx.userData?.type === 'SUPERADMIN')
                          ? (_openBlock(), _createElementBlock("th", _hoisted_23, "Action"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: dataItem.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          (_ctx.userData?.type =='SUPERADMIN')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(dataItem.type?.title), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, _toDisplayString(dataItem.name), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.category.name), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.unit), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.buy_price), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.sell_price), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.alert_quantity), 1),
                          (_ctx.userData?.type == 'SUPERADMIN')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                                _createVNode(_component_router_link, {
                                  class: "me-2 btn btn-sm btn-warning",
                                  to: { name: 'product-form', params: { id: dataItem.id.toString() } }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pen-to-square'] })
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "me-2 btn btn-sm btn-danger",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#modalCenter",
                                  onClick: ($event: any) => (_ctx.fetchItem(dataItem))
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash-can'] })
                                ], 8, _hoisted_27)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
        : _createCommentVNode("", true),
      (_ctx.fettchDataArray.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card mb-4",
                key: dataItem.id
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("strong", _hoisted_37, " Product Name: " + _toDisplayString(dataItem.name), 1),
                  _hoisted_38,
                  (_ctx.userData?.type == 'SUPERADMIN')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_39, "Store Type: " + _toDisplayString(dataItem.type?.title), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_40, "Category / Generic: " + _toDisplayString(dataItem.category.name), 1),
                  _createElementVNode("p", _hoisted_41, "Unit: " + _toDisplayString(dataItem.unit), 1),
                  _createElementVNode("p", _hoisted_42, "Buy Price: " + _toDisplayString(dataItem.buy_price), 1),
                  _createElementVNode("p", _hoisted_43, "Sell Price: " + _toDisplayString(dataItem.sell_price), 1),
                  _createElementVNode("p", null, "Alert Quantity: " + _toDisplayString(dataItem.alert_quantity), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "me-2 btn btn-sm btn-warning",
                    onClick: ($event: any) => (_ctx.editItem(dataItem.id.toString()))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pen-to-square'] })
                  ], 8, _hoisted_44),
                  _createElementVNode("button", {
                    type: "button",
                    class: "me-2 btn btn-sm btn-danger",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modalCenter",
                    onClick: ($event: any) => (_ctx.fetchItem(dataItem))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash-can'] })
                  ], 8, _hoisted_45)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_48))
    ]),
    (_ctx.fettchDataArray.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("nav", _hoisted_51, [
              _createElementVNode("ul", _hoisted_52, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationData.links, (page, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: _normalizeClass(["page-item myPagination m-1", { active: page.active }])
                  }, [
                    _createElementVNode("button", {
                      class: "page-link",
                      onClick: ($event: any) => (_ctx.goToPage(Number(page.label))),
                      innerHTML: page.label
                    }, null, 8, _hoisted_53)
                  ], 2))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    id: "inputGroupSelect01",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchData && _ctx.fetchData(...args)))
                  }, _hoisted_64, 544), [
                    [_vModelSelect, _ctx.pageSize]
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _hoisted_68,
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _hoisted_71,
            _createElementVNode("p", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.deletevalue.name), 1),
              _hoisted_72
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("button", {
              "data-bs-dismiss": "modal",
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteItem(_ctx.deletevalue.id)))
            }, "Confirm")
          ])
        ])
      ])
    ])
  ]))
}